var _rect, _rect2, _rect3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 148,
    viewBox: "0 0 184 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86.4551,
    y: 12.23,
    width: 96.0696,
    height: 107.346,
    rx: 7.88631,
    transform: "rotate(3.49185 86.4551 12.23)",
    fill: "#F5F5F7",
    stroke: "#DEDEDE",
    strokeWidth: 1.43387
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.74864,
    y: 21.4746,
    width: 96.0696,
    height: 108.02,
    rx: 7.88631,
    transform: "rotate(-12.3945 1.74864 21.4746)",
    fill: "#F5F5F7",
    stroke: "#DEDEDE",
    strokeWidth: 1.43387
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4953,
    y: 36.5636,
    width: 96.0696,
    height: 110.408,
    rx: 7.88631,
    fill: "#F5F5F7",
    stroke: "#DEDEDE",
    strokeWidth: 1.43387
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_761_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.5315 96.0689C95.9118 96.0689 96.2765 95.9179 96.5454 95.649C96.8143 95.38 96.9654 95.0153 96.9654 94.635V83.7577L100.252 87.047C100.521 87.3162 100.886 87.4675 101.267 87.4675C101.648 87.4675 102.013 87.3162 102.282 87.047C102.551 86.7777 102.703 86.4126 102.703 86.0318C102.703 85.651 102.551 85.2859 102.282 85.0166L96.5467 79.2811C96.4135 79.1476 96.2553 79.0416 96.0811 78.9694C95.9069 78.8971 95.7201 78.8599 95.5315 78.8599C95.3429 78.8599 95.1562 78.8971 94.982 78.9694C94.8078 79.0416 94.6495 79.1476 94.5164 79.2811L88.7809 85.0166C88.5116 85.2859 88.3604 85.651 88.3604 86.0318C88.3604 86.4126 88.5116 86.7777 88.7809 87.047C89.0501 87.3162 89.4153 87.4675 89.796 87.4675C90.1768 87.4675 90.542 87.3162 90.8112 87.047L94.0977 83.7577V94.635C94.0977 95.0153 94.2487 95.38 94.5176 95.649C94.7865 95.9179 95.1512 96.0689 95.5315 96.0689Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0597 64.5239C82.5386 64.5239 81.0797 65.1282 80.0041 66.2038C78.9285 67.2794 78.3242 68.7383 78.3242 70.2594V104.672C78.3242 106.194 78.9285 107.652 80.0041 108.728C81.0797 109.804 82.5386 110.408 84.0597 110.408H107.002C108.523 110.408 109.982 109.804 111.057 108.728C112.133 107.652 112.737 106.194 112.737 104.672V70.2594C112.737 68.7383 112.133 67.2794 111.057 66.2038C109.982 65.1282 108.523 64.5239 107.002 64.5239H84.0597ZM84.0597 67.3917H107.002C107.762 67.3917 108.492 67.6938 109.03 68.2316C109.567 68.7694 109.869 69.4989 109.869 70.2594V104.672C109.869 105.433 109.567 106.162 109.03 106.7C108.492 107.238 107.762 107.54 107.002 107.54H84.0597C83.2991 107.54 82.5697 107.238 82.0319 106.7C81.4941 106.162 81.192 105.433 81.192 104.672V70.2594C81.192 69.4989 81.4941 68.7694 82.0319 68.2316C82.5697 67.6938 83.2991 67.3917 84.0597 67.3917Z",
    fill: "#929292"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_761_3634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.884,
    height: 45.884,
    fill: "white",
    transform: "translate(72.5879 64.5244)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/uploadicon.2e1e99906874e6d166bfb8eb3e2a75fd.svg";
export { ForwardRef as ReactComponent };